<template>
  <div>
    <b-modal :active.sync="show" has-modal-card>
      <form action="">
        <div class="modal-card" style="width: auto">
          <header class="modal-card-head is-bg-primary">
            <p class="modal-card-title has-text-white">KRS <span v-if="!isEmpty(account)"> - {{ account.name }}</span></p>
          </header>
          <section class="modal-card-body">
            <b-field label="Periode">
              <b-select placeholder="Pilih periode" v-model="periode_krs">
                <option
                  v-for="(periode, key) in periode_krs_collection"
                  :value="periode.id"
                  :key="key">
                  {{ periode.name }}
                </option>
              </b-select>
            </b-field>

            <b-table v-if="!isEmpty(data_krs)" :data="data_krs.mataKuliah">
              <template slot-scope="props">
                <b-table-column field="namaMataKuliah" label="Mata Kuliah">
                  <p class="title" style="font-size: 15px;">{{ props.row.namaMataKuliah }}&nbsp;|&nbsp;{{ props.row.kodeMataKuliah }}</p>
                  <p class="subtitle" style="font-size: 14px;">
                    <span class="icon"><i class="fa fa-user"></i></span>
                    <span>{{ props.row.namaDosen || '-' }}</span>
                  </p>
                </b-table-column>

                <b-table-column field="sks" label="SKS">
                  {{ props.row.sks || '0' }} SKS
                </b-table-column>

                <b-table-column field="jadwal" label="Jadwal">
                  {{ props.row.jadwal || '-' }}
                </b-table-column>
              </template>
            </b-table>
          </section>
          <footer class="modal-card-foot">
          </footer>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { ACCOUNT } from '~/consts';

export default {
  props: {
    account: {
      type: Object,
      default: null
    },
    onHide: {
      type: Function,
      default: () => {}
    }
  },

  computed: {
    nim() {
      if (!this.isEmpty(this.account)) {
        return this.account.userUniversityId
      }

      return null;
    },
    periode_krs_collection() {
      return collect(this.krs).map((i) => {
        return {
          id: i.periode,
          name: i.periode
        }
      }).toArray()
    },
    data_krs() {
      if (!this.isEmpty(this.krs)) {
        return collect(this.krs).where('periode', this.periode_krs).first();
      }

      return [];
    },
    show: {
      get() {
        return !this.isEmpty(this.nim) ? true : false
      },
      set() {
        this.onHide();
      }
    }
  },

  watch: {
    account(val) {
      if (!this.isEmpty(val)) {
        this.getData()
      } else {
        this.krs = [];
        this.periode_krs = null
      }
    },
  },

  data() {
    return {
      periode_krs: null,
      krs: [],
    }
  },

  methods: {
    getData() {
      const vm = this;

      this.$axios.post(ACCOUNT.GET_KRS(this.account.universityId), {
        isDefault: 0,
        user_university_id: this.nim
      }).then(({ data }) => {
        if (data.applicationSystem.code == 0) {
          vm.krs = data.data;
        } else {
          this.$buefy.toast.open(data.applicationSystem.message);
        }
      }).catch(({ response }) => {
      })
    }
  }
}
</script>

<style>

</style>
